import { FlexContainer } from './FlexContainer';
import { Grid, Stack, Typography } from '@mui/material';
import { useMemo } from 'react';

export interface TwoColumnDataGridProps {
  data: string[];
  title?: string;
  emptyDataMessage?: string;
}

type ColumnData = {
  leftColumn: string[];
  rightColumn: string[];
};

export const TwoColumnDataGrid = ({
  data,
  title,
  emptyDataMessage = 'No data available.',
}: TwoColumnDataGridProps) => {
  // Split the data into two columns
  const columns: ColumnData = useMemo(() => {
    // Left column gets the extra item if the data length is odd
    const middleIndex = Math.ceil(data.length / 2);
    return {
      leftColumn: data.slice(0, middleIndex),
      rightColumn: data.slice(middleIndex),
    };
  }, [data]);

  // Render the data grid in a flex container to allow for a title
  return (
    <FlexContainer direction="column" gap={2} height="fit-content" width="100%">
      {title && (
        <Typography variant="bodyLarge" fontWeight="bold">
          {title}
        </Typography>
      )}
      {/* Container for the two columns of data */}
      {data.length && (
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6}>
            <Stack spacing={1}>
              {/* Map over the left column */}
              {columns.leftColumn.map(dataItem => (
                <Typography
                  variant="bodyMedium"
                  key={`left-column-${dataItem}`}
                >
                  {dataItem}
                </Typography>
              ))}
            </Stack>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Stack spacing={1}>
              {/* Map over the right column */}
              {columns.rightColumn.map(dataItem => (
                <Typography
                  variant="bodyMedium"
                  key={`right-column-${dataItem}`}
                >
                  {dataItem}
                </Typography>
              ))}
            </Stack>
          </Grid>
        </Grid>
      )}
      {!data.length && (
        <Typography variant="bodyMedium">{emptyDataMessage}</Typography>
      )}
    </FlexContainer>
  );
};
